"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.LogPostQueueService = void 0;
var _endsWith = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/ends-with"));
var _slice = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/slice"));
var _pageHttpClient = _interopRequireDefault(require("@qualtrics/page-http-client"));
var _QueueFacade = require("./QueueFacade");
var normalizeUrl = function normalizeUrl(url) {
  return (0, _endsWith.default)(url).call(url, '?') ? (0, _slice.default)(url).call(url, 0, url.length - 1) : url;
};
var LogPostQueueService = exports.LogPostQueueService = function LogPostQueueService(section, meta) {
  return (0, _QueueFacade.LogQueueFacade)(section, meta, function (_ref) {
    var log = _ref.log,
      url = _ref.url;
    return _pageHttpClient.default.post(normalizeUrl(url), log);
  }, '/rum/genesis-dev-client-logging');
};
//# sourceMappingURL=logPostQueueService.js.map